import {FlipDownCounter} from "./FlipDownCounter";

export class VterinaCounter {
    static init() {
        FlipDownCounter.initVterinaCounter();
    }

    static increment() {
        var $ = jQuery;

        //
        $('.js-vterina-incrementable').each(function (index, elem) {
            const $elem = $(elem);
            let incrementor = parseInt($elem.attr('data-incrementor'));
            incrementor = isNaN(incrementor) ? 1 : incrementor;
            //
            let html = $elem.html();
            let text = '';
            //
            if ($elem.attr('data-html')) {
                html = $elem.attr('data-html');
            }
            // Create temp div
            var tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;
            text = tempDiv.textContent || tempDiv.innerText || "";
            //
            let numPart = parseFloat(text);

            //
            if (isNaN(numPart)) {
                // console.log("NAN " + $elem.text());
                return;
            }

            // Store data
            $elem.attr('data-html', html.replace(numPart, (numPart + incrementor)));
            $elem.attr('data-html', html.replace(numPart, (numPart + incrementor)));
            //
            const newHtml = html.replace(numPart, (numPart + incrementor).toLocaleString());
            //
            $elem.html(newHtml)
        });
    }
}